import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import DialogHeader from "../../components/dialog/DialogHeader";
import DialogBody from "./../../components/dialog/DialogBody";
import DialogActionButtons from "../../components/dialog/DialogActions";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = {};

const ConfirmRequestDialog = forwardRef(({ handleConfirm }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader title={"Confirmation!"} onClose={handleClose} />
      <DialogBody>
        <Typography
          variant="body1"
          textAlign={"center"}
          color="text.orangeRed"
          maxWidth={300}
          margin={"auto"}
        >
          Are You sure you want to send this Admission request to “ABC school” ?
        </Typography>
      </DialogBody>
      <DialogActionButtons onCancel={handleClose} onConfirm={handleConfirm} />
    </BootstrapDialog>
  );
});

export default ConfirmRequestDialog;
